import { type SkillDTOV2 } from '@/common/types/skills'

export const getSkillByCode = (skills: SkillDTOV2[], skillCode: string) => {
  return skills.find((skill) => skill.code === skillCode)
}
